export function storageUrl(url) {
    if (url.indexOf('http:') > -1 || url.indexOf('https:') > -1) {
        return url;
    }

    return storage_url + url;
}
